import { debug, NetbankingAPI } from "aaa";
import { action, computed, observable } from "mobx";
import { NetbankingAPIClient } from "network/APIClient";
import { ICard } from "types/card";
import { IFee } from "types/fee";
import { gba } from "util/georgeBusinessAdapter";

export type PinResetError = "FeeNotFound";

/**
 * Infos for a single card
 */
export class CardStore {
    @observable card?: ICard;
    @observable cardFees?: Array<IFee>;

    @observable isCardLoading: boolean = false;
    @observable isFeesLoading: boolean = false;

    @computed get isLoading() {
        return this.isCardLoading || this.isFeesLoading;
    }

    /**
     * @deprecated Use FeeStore instead 
     */
    @action loadCardAndFees(cardId: string) {
        return Promise.all([this.loadCard(cardId), this.loadFees(cardId)]);
    }

    /**
     * Load card details
     */
    @action async loadCard(cardId: string) {
        try {
            this.isCardLoading = true;
            const card = await gba.getCard(cardId);
            this.card = card.card ?? card;
            debug.log("### card", card);
        } finally {
            this.isCardLoading = false;
        }
    }

    /**
     * Load fees for various services
     * @deprecated Use FeeStore instead
     */
    @action async loadFees(cardId: string) {
        const target = NetbankingAPI.getFeesOfCard(cardId);
        this.isFeesLoading = true;

        try {
            const result = await NetbankingAPIClient.requestType(target);
            this.cardFees = result.fees;
            this.isFeesLoading = false;
            debug.log("### fees", result);
        } catch (error) {
            this.isFeesLoading = false;
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./src/stores/CardStore.ts